import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import IconSave from '@mui/icons-material/Save';
import { useState } from 'react';
import { email as validateEmail, useNotify, useRefresh } from 'react-admin';
import { useRecordContext } from 'ra-core';
import { KycUserProps } from '../../utils/KycApi';
import UserListHandler from '../../react-admin/providers/handlers/UserListHandler';

const useChangeEmail = ({ setShow, userId }: { setShow: (flag: boolean) => void; userId: string | undefined }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const validator = validateEmail();
  const notify = useNotify();

  const refresh = useRefresh();
  const close = () => {
    setLoading(false);
    setShow(false);
  };
  const changeEmail = async () => {
    setLoading(true);
    if (email !== '' && userId != null && validator(email) == null) {
      UserListHandler.updateUserEmail(
        userId,
        email,
        () => {
          refresh();
          close();
        },
        (e: any) => {
          notify(e.toString(), { type: 'error' });
          close();
        }
      );
    } else {
      close();
    }
  };

  return {
    email,
    setEmail: (event: any) => {
      setEmail(event.target.value);
      console.log(validator(email));
    },
    changeEmail,
    close,
    loading,
  };
};

export const ChangeEmailAction = () => {
  const user = useRecordContext() as KycUserProps & { id: string };
  const validator = validateEmail();
  const [show, setShow] = useState(false);
  const { email, setEmail, changeEmail, close, loading } = useChangeEmail({
    setShow,
    userId: user?.id as string,
  });

  return (
    <>
      <Button color="primary" onClick={() => setShow(true)}>
        Change Email Address
      </Button>
      <Dialog fullWidth open={show} onClose={setShow} aria-label="Change Email Address">
        <DialogTitle>Change Email Address</DialogTitle>
        <DialogContent>
          <Grid item xs={12}>
            <TextField
              id="email"
              type="email"
              placeholder="Email address"
              variant="outlined"
              fullWidth
              value={email}
              onChange={setEmail}
            />
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={close} disabled={loading}>
            <IconCancel />
            <span>Close</span>
          </Button>
          <Button onClick={changeEmail} disabled={email === '' || loading || validator(email) != null}>
            <IconSave />
            <span>Save</span>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
